import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { MarketingForm } from "@/components/marketing/MarketingForm";
import { MarketingActions } from "@/components/marketing/MarketingActions";
import { MarketingResult } from "@/components/marketing/MarketingResult";
import { MarketingGallery } from "@/components/marketing/MarketingGallery";
import { DeckSection } from "@/components/marketing/DeckSection";

const PATHS = { image: "/marketing/image", ai_image: "/marketing/ai-image", copy: "/marketing/copy", flyer: "/marketing/flyer" };
const DONE = { image: "Imagen de marca lista", ai_image: "Imagen creativa generada", copy: "Textos generados", flyer: "Flyer PDF listo" };

export default function Marketing() {
  const [opts, setOpts] = useState(null);
  const [sel, setSel] = useState({ slug: "credito-pyme", format: "post", campaign: "", tone: "profesional", headline: "", sub: "", phone: "" });
  const [busy, setBusy] = useState(null);
  const [result, setResult] = useState(null);
  const [assets, setAssets] = useState([]);
  const loadAssets = () => api.get("/marketing/assets").then(({ data }) => setAssets(data)).catch(() => {});
  useEffect(() => {
    api.get("/marketing/options").then(({ data }) => { setOpts(data); const active = data.campaigns.find((c) => c.active && (c.products || []).includes("credito-pyme")); setSel((s) => ({ ...s, phone: data.owner.phone || "", campaign: active?.key || "" })); }).catch((e) => toast.error(errMsg(e)));
    loadAssets();
  }, []);
  const run = async (kind) => {
    setBusy(kind);
    try {
      const body = { slug: sel.slug, campaign: sel.campaign || null };
      if (kind === "image" || kind === "ai_image") Object.assign(body, { format: sel.format, headline: sel.headline || null, sub: sel.sub || null, phone: sel.phone || null });
      if (kind === "copy") body.tone = sel.tone;
      const { data } = await api.post(PATHS[kind], body);
      setResult({ kind, data });
      if (kind !== "copy") loadAssets();
      toast.success(DONE[kind]);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const del = async (a) => { if (!window.confirm("¿Eliminar este material?")) return; try { await api.delete(`/marketing/assets/${a.id}`); setAssets(assets.filter((x) => x.id !== a.id)); if (result?.data?.id === a.id) setResult(null); } catch (e) { toast.error(errMsg(e)); } };
  if (!opts) return <div className="text-sm text-[#8A8A8A]" data-testid="mkt-loading">Cargando Marketing Hub…</div>;
  return (
    <div className="space-y-8" data-testid="marketing-page">
      <div className="rounded-3xl ink grain relative overflow-hidden p-6 sm:p-8" data-testid="marketing-hero">
        <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#FF7A00]/35 blur-3xl" />
        <div className="relative flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div><p className="eyebrow" style={{ color: "#FFC629" }}>Marketing Hub</p><h1 className="font-display font-bold text-2xl sm:text-3xl text-white">Materiales listos para compartir</h1><p className="text-sm text-white/65 mt-1 max-w-2xl">Posts, historias, banners, flyers y textos con tu nombre, WhatsApp, QR y liga con atribución. Los textos e imágenes creativas se generan con IA; revísalos antes de publicar.</p></div>
          <div className="flex gap-4 text-white shrink-0" data-testid="marketing-stats">{[[assets.length, "materiales"], [assets.filter((a) => a.kind === "ai_image").length, "con IA"], [opts.campaigns.filter((c) => c.active).length, "campañas activas"]].map(([v, l]) => <div key={l}><div className="font-display font-extrabold text-2xl text-[#FFC629]">{v}</div><div className="text-[11px] text-white/55">{l}</div></div>)}</div>
        </div>
      </div>
      <div className="grid lg:grid-cols-[1fr_1.1fr] gap-6 items-start">
        <div className="space-y-4">
          <MarketingForm opts={opts} sel={sel} setSel={setSel} />
          <MarketingActions owner={opts.owner} busy={busy} onRun={run} />
        </div>
        <MarketingResult result={result} busy={busy} onRegenerate={result && PATHS[result.kind] ? () => run(result.kind) : undefined} />
      </div>
      <DeckSection owner={opts.owner} onCreated={(a) => { setResult({ kind: "deck", data: a }); loadAssets(); }} />
      <MarketingGallery assets={assets} onDelete={del} onSelect={(a) => setResult({ kind: a.kind, data: a })} />
    </div>
  );
}
